import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metodologias',
  templateUrl: './metodologias.component.html',
  styleUrls: ['./metodologias.component.css']
})
export class MetodologiasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
